module.exports = __webpack_public_path__ + "img/icon-female.37c94826.svg";